import React, { useState } from "react";
import { IDocument } from "../../interfaces/IDocument";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface IProps {
    documentObject: IDocument | null;
    Width?: number;
    Height?: number;
}

export const PDFViewer: React.FC<IProps> = ({ documentObject }) => {
    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [zoomLevel, setZoomLevel] = useState<number>(1.0); // 🔍 Zoom

    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }

    const nextPage = () => pageNumber < numPages && setPageNumber(pageNumber + 1);
    const previousPage = () => pageNumber > 1 && setPageNumber(pageNumber - 1);

    const zoomIn = () => setZoomLevel((prev) => Math.min(prev + 0.1, 3));
    const zoomOut = () => setZoomLevel((prev) => Math.max(prev - 0.1, 0.5));

    const tsxButtons = () => (
        <Box mb={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">
                    Seite {pageNumber} von {numPages}
                </Typography>

                <Stack direction="row" spacing={2}>
                    <Button onClick={previousPage} variant="outlined" startIcon={<ArrowBackIos fontSize="small" />}>
                        Vorherige Seite
                    </Button>
                    <Button onClick={nextPage} variant="outlined" endIcon={<ArrowForwardIos fontSize="small" />}>
                        Nächste Seite
                    </Button>
                </Stack>

                <Stack direction="row" spacing={1}>
                    <Button onClick={zoomOut} variant="outlined">
                        -
                    </Button>
                    <Button onClick={zoomIn} variant="outlined">
                        +
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );

    if (!documentObject?.data) {
        return <Alert severity="info">Keine Dateien zum Render gefunden</Alert>;
    }

    if (documentObject.MIMEtype.MIMEtype !== "application/pdf") {
        return <Alert severity="warning">Datentyp wird nicht unterstützt!</Alert>;
    }

    return (
        <>
            {tsxButtons()}
            <Document file={`data:application/pdf;base64,${documentObject.data}`} onLoadSuccess={onDocumentLoadSuccess}>
                <Box display="flex" justifyContent="center">
                    <Page
                        pageNumber={pageNumber}
                        scale={zoomLevel}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                    />
                </Box>
            </Document>

            {tsxButtons()}
        </>
    );
};
